module.exports = __webpack_public_path__ + "static/media/no-image.89495f57.jpg";